export enum SystemResponseRatingEnum
{
    Helpful = 'Helpful',
    UnHelpful = 'UnHelpful',
    NotRelated = 'NotRelated'
}

export const SystemResponseRatingOptions = (): Option[] => ([
    { value: SystemResponseRatingEnum.Helpful, text: $t('[[[Pomocna]]]') },
    { value: SystemResponseRatingEnum.UnHelpful, text: $t('[[[Nie pomocna]]]') },
    { value: SystemResponseRatingEnum.NotRelated, text: $t('[[[Nie związana]]]') }
]);

export const SystemResponseRatingName = (value: SystemResponseRatingEnum): string => SystemResponseRatingOptions().find(p => p.value === value)?.text || SystemResponseRatingEnum[value];
